import {createApi, createApiClient} from "@3dcalc/3dpClient";
import {initParam} from "../setting/initParam";

const client = createApiClient({
    apiUrl: 'https://3dpapi.deallog.pro/api/v1',
    // apiUrl: 'http://localhost:3300/api/v1',
    apiKey: '07165eb0cc56e66723804230fcff3a04778cf700c0bdf31da9752859784334df',
    calculatorId: '1ea49d07-771c-4691-90dc-c8475d2a83df',
    onError: (error) => {
        console.error('API Error:', error);
    },
    onUnauthorized: () => {
        console.error('Unauthorized! Check your API key');
    }
});

const { config } = await client.init();
Object.assign(initParam, config);

export const api = createApi(client);
